import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgForOf } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TuiBreadcrumbsModule } from '@taiga-ui/kit';
import { TuiLinkModule, TuiSizeL, TuiSizeM } from '@taiga-ui/core';
import { Breadcrumb } from '@us/web/shared/data-access';

@Component({
    selector: 'us-breadcrumbs',
    standalone: true,
    imports: [RouterModule, TuiBreadcrumbsModule, NgForOf, TuiLinkModule],
    template: `
        <div class="mb-2">
            <tui-breadcrumbs [size]="size">
                <ng-container *ngFor="let item of items">
                    <a *tuiItem tuiLink [routerLink]="item.routerLink" [class.text-primary]="!!item.routerLink">
                        {{ item.title }}
                    </a>
                </ng-container>
            </tui-breadcrumbs>
        </div>
    `,
    styles: [
        `
            :host {
                display: block;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbsComponent {
    @Input() size: TuiSizeM | TuiSizeL = 'l';
    @Input() items: Breadcrumb[] = [];
}
